// removed by extract-text-webpack-plugin
module.exports = {"safetyDocItemIcon":"r2F90bEklekQ0ItebThHV"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/componentStyle/safetyDocItemIcon.scss
// module id = 13052
// module chunks = 0